<template>
  <div class="" id="foto-header">
    <header class="header">
      <div class="container">
        <div class="logo_wrap">
          <a href="/">
            <img
              width="142"
              height="22"
              :src="cdnUrl + '/sharkfoto-logo.svg'"
              alt=""
            />
          </a>
        </div>

        <el-menu
          :default-active="routePath"
          class="foto_navbar"
          mode="horizontal"
          text-color="#3D3D3D"
          active-text-color="#3D3D3D"
          @select="handleSelect"
          :ellipsis="false"
          :offset="10"
        >
          <el-sub-menu index="PhotoAI">
            <template #title>Photo AI</template>
            <el-menu-item index="/ai/image/text-to-image/">
              <nuxt-link to="/ai/image/text-to-image/">Text To Image</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/ai/image/image-to-image/">
              <nuxt-link to="/ai/image/image-to-image/"
                >Image To Image</nuxt-link
              >
            </el-menu-item>
            <el-menu-item index="/ai/image/background-remover/">
              <nuxt-link to="/ai/image/background-remover/">BGRemover</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/image-colorizer/">
              <nuxt-link to="/image-colorizer/">ImageColorizer</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/image-enhancer/">
              <nuxt-link to="/image-enhancer/">ImageEnhancer</nuxt-link>
            </el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="group-video">
            <template #title>Video AI</template>
            <el-menu-item index="/ai/video/text-to-video/">
              <nuxt-link to="/ai/video/text-to-video/">Text To Video</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/ai/video/image-to-video/">
              <nuxt-link to="/ai/video/image-to-video/"
                >Image To Video</nuxt-link
              >
            </el-menu-item>
            <el-menu-item index="/ai/video/watermark-remover/">
              <nuxt-link to="/ai/video/watermark-remover/"
                >Watermark Remover</nuxt-link
              >
            </el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="PhotoEditing">
            <template #title>Photo Editing</template>
            <el-menu-item index="/image-converter/">
              <nuxt-link to="/image-converter/">ImageConverter</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/image-compressor/">
              <nuxt-link to="/image-compressor/">ImageCompressor</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/image-resizer/">
              <nuxt-link to="/image-resizer/">ImageResizer</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/image-cropper/">
              <nuxt-link to="/image-cropper/">ImageCropper</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/image-flipper/">
              <nuxt-link to="/image-flipper/">ImageFlipper</nuxt-link>
            </el-menu-item>
            <el-menu-item index="/image-rotater/">
              <nuxt-link to="/image-rotater/">ImageRotater</nuxt-link>
            </el-menu-item>
            <!-- <el-menu-item index="/app/?tool=editor">
              <nuxt-link to="/app/?tool=editor">ImageEditor</nuxt-link>
            </el-menu-item> -->
          </el-sub-menu>
          <!-- <el-menu-item index="/gallery/">
            <a href="/gallery/">Free PNG</a>
          </el-menu-item> -->
          <el-menu-item index="/pricing/">
            <a href="/pricing/">Pricing</a>
          </el-menu-item>
          <el-menu-item index="/blog/">
            <a href="https://sharkfoto.com/blog/" target="_blank">Blog</a>
          </el-menu-item>
        </el-menu>

        <el-menu
          :default-active="routePath"
          class="foto_navbar"
          mode="horizontal"
          text-color="#3D3D3D"
          active-text-color="#3D3D3D"
          @select="handleSelect"
          :ellipsis="false"
          :offset="10"
        >
          <el-menu-item index="/sign-in/" v-show="!token">
            <nuxt-link to="/sign-in/" target="_blank">Sign In</nuxt-link>
          </el-menu-item>
          <!-- <el-menu-item
            index="/my/dashboard/"
            class="account_area remove"
            v-show="token"
          >
            <a class="btn_account" href="/my/dashboard/" target="_blank"
              >My Account</a
            >
          </el-menu-item> -->
          <el-menu-item
            index="/my/plan-credits/"
            class="account_area remove"
            v-show="token"
          >
            <a class="btn_account" href="/my/plan-credits/" target="_blank"
              >My Account</a
            >
          </el-menu-item>
          <el-menu-item
            index="/sign-up/"
            class="account_area remove"
            v-show="!token"
          >
            <nuxt-link target="_blank" class="btn_sign_up p-0" to="/sign-up/"
              >Sign Up Free</nuxt-link
            >
          </el-menu-item>
        </el-menu>
        <div
          class="more_navbar"
          @click="drawer = true"
          style="margin-left: 16px"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="25"
            height="20"
            viewBox="0 0 45 35"
          >
            <path
              d="M41.25,0L3.74999,0C1.68893,0,0,1.0374,0,3.22659C0,5.41568,1.68893,6.45308,3.74999,6.45308L41.25,6.45308C43.3111,6.45308,45,5.41568,45,3.22659C44.9949,1.03223,43.3111,0,41.25,0ZM41.25,14.4513L3.74999,14.4513C1.68893,14.4513,0,15.4888,0,17.6779C0,19.8671,1.68893,20.9045,3.74999,20.9045L41.25,20.9045C43.3111,20.9045,45,19.8671,45,17.6779C44.9949,15.4835,43.3111,14.4513,41.25,14.4513ZM41.25,28.5469L3.74999,28.5469C1.68893,28.5469,0,29.5843,0,31.7734C0,33.9623,1.68893,35,3.74999,35L41.25,35C43.3111,35,45,33.9623,45,31.7734C44.9949,29.5788,43.3111,28.5469,41.25,28.5469Z"
              fill="#3D3D3D"
              fill-opacity="1"
            />
          </svg>
        </div>

        <el-drawer
          title=""
          v-model="drawer"
          direction="ltr"
          size="50%"
          :with-header="false"
        >
          <el-menu
            class="left-menu"
            :default-active="routePath"
            text-color="#3D3D3D"
            active-text-color="#3D3D3D"
            @select="handleSelect"
          >
            <el-sub-menu index="PhotoAI">
              <template #title>Photo AI</template>
              <el-menu-item index="/ai/image/text-to-image/">
                <nuxt-link to="/ai/image/text-to-image/"
                  >Text To Image</nuxt-link
                >
              </el-menu-item>
              <el-menu-item index="/ai/image/image-to-image/">
                <nuxt-link to="/ai/image/image-to-image/"
                  >Image To Image</nuxt-link
                >
              </el-menu-item>
              <el-menu-item index="/ai/video/text-to-video/">
                <nuxt-link to="/ai/video/text-to-video/"
                  >Text To Video</nuxt-link
                >
              </el-menu-item>
              <el-menu-item index="/ai/video/image-to-video/">
                <nuxt-link to="/ai/video/image-to-video/"
                  >Image To Video</nuxt-link
                >
              </el-menu-item>
              <el-menu-item index="/ai/image/background-remover/">
                <nuxt-link to="/ai/image/background-remover/">BGRemover</nuxt-link></el-menu-item
              >
              <el-menu-item index="/image-colorizer/">
                <nuxt-link to="/image-colorizer/"
                  >ImageColorizer</nuxt-link
                ></el-menu-item
              >
              <el-menu-item index="/image-enhancer/">
                <nuxt-link to="/image-enhancer/"
                  >ImageEnhancer</nuxt-link
                ></el-menu-item
              >
            </el-sub-menu>
            <el-sub-menu index="PhotoEditing">
              <template #title>Photo Editing</template>
              <el-menu-item index="/image-converter/">
                <nuxt-link to="/image-converter/">ImageConverter</nuxt-link>
              </el-menu-item>
              <el-menu-item index="/image-compressor">
                <nuxt-link to="/image-compressor/">ImageCompressor</nuxt-link>
              </el-menu-item>
              <el-menu-item index="/image-resizer/">
                <nuxt-link to="/image-resizer/">ImageResizer</nuxt-link>
              </el-menu-item>
              <el-menu-item index="/image-cropper/">
                <nuxt-link to="/image-cropper/">ImageCropper</nuxt-link>
              </el-menu-item>
              <el-menu-item index="/image-flipper/">
                <nuxt-link to="/image-flipper/">ImageFlipper</nuxt-link>
              </el-menu-item>
              <el-menu-item index="/image-rotater/">
                <nuxt-link to="/image-rotater/">ImageRotater</nuxt-link>
              </el-menu-item>
              <!-- <el-menu-item index="/app/?tool=editor">
                <nuxt-link to="/app/?tool=editor">ImageEditor</nuxt-link>
              </el-menu-item> -->
            </el-sub-menu>
            <!-- <el-menu-item index="/gallery/">
              <a href="/gallery/">Free PNG</a>
            </el-menu-item> -->
            <el-menu-item index="/pricing/">
              <a href="/pricing/">Pricing</a>
            </el-menu-item>
            <el-menu-item index="/blog/">
              <a href="https://sharkfoto.com/blog/" target="_blank">Blog</a>
            </el-menu-item>
            <el-menu-item v-show="!token" index="/sign-in/">
              <nuxt-link to="/sign-in/" target="_blank">Sign In</nuxt-link>
            </el-menu-item>
            <!-- <el-menu-item
              index="/my/dashboard/"
              class="account_area"
              v-show="token"
            >
              <a class="btn_account" href="/my/dashboard/" target="_blank"
                >My Account</a
              >
            </el-menu-item> -->
            <el-menu-item
              index="/my/plan-credits/"
              class="account_area remove"
              v-show="token"
            >
              <a class="btn_account" href="/my/plan-credits/" target="_blank"
                >My Account</a
              >
            </el-menu-item>
            <el-menu-item
              index="/sign-up/"
              class="account_area"
              v-show="!token"
            >
              <nuxt-link class="btn_account" target="_blank" to="/sign-up/"
                >Sign Up Free</nuxt-link
              >
            </el-menu-item>
          </el-menu>
        </el-drawer>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { computed, nextTick } from "vue";
import { useRoute } from "#imports";
export default {
  name: "fotoHeader",
  props: {
    page: {
      default: "",
    },
  },
  setup() {
    const route = useRoute();
    const routePath = computed(() => (route && route.path ? route.path : "/"));
    return { routePath };
  },
  data() {
    return {
      drawer: false,
      cdnUrl: useRuntimeConfig().public.cdnUrl,
    };
  },
  computed: {
    ...mapState("user", ["token", "userInfo"]),
    // isGallery(){
    //   // 判断是不是gallery页面 如果是的话 把头部的logo切换成gallery的
    //   // console.log('this.$route.path.split()!=-1:',this.$route.path.indexOf('/gallery/')!=-1)
    //   // console.log('this.$route.path.split()!=-1:',this.$route.path.indexOf('/gallery/'))
    // if(this.$route.path.indexOf('/gallery')!=-1){
    //   return true
    // }else{
    //   return false
    // }
    // }
  },
  methods: {
    ...mapMutations("image", ["SET_LARGE_ITEM"]),
    handleSelect(e) {
      if (this.drawer) {
        this.drawer = false;
      }
    },
  },
  watch: {
    token() {
      if (!this.token) {
        this.SET_LARGE_ITEM(null);
      }
    },
  },
};
</script>

<style>
.el-menu.el-menu--horizontal,
.el-sub-menu.is-active .el-sub-menu__title,
.el-menu-item.account_area,
.el-menu--horizontal > .el-menu-item.is-active,
.el-menu--horizontal > .el-sub-menu.is-active .el-sub-menu__title,
.foto_navbar .el-sub-menu .el-menu-item .foto_navbar .el-sub-menu__title,
.el-menu--horizontal > .el-sub-menu .el-sub-menu__title {
  border-bottom-color: rgba(0, 0, 0, 0) !important;
  border-color: rgba(0, 0, 0, 0) !important;
  border: 0 !important;
}
.el-menu--horizontal .el-menu .el-menu-item {
  height: 48px;
  line-height: 48px;
  padding: 0 12px;
  font-weight: 600;
}
.el-menu--horizontal .el-menu .el-menu-item:hover {
  background: #f9f5ff;
}
.el-menu--popup {
  padding: 10px 0;
}
.el-menu--horizontal a {
  color: #3d3d3d;
}

.el-menu a {
  display: block;
  width: 100%;
}

/* 1) teleported 弹层里的 <a>：去掉程序化 focus 的黑框 */
.el-menu__popup .el-menu-item a:focus,
.el-menu__popup .el-menu-item a:focus-visible,
.el-menu--popup .el-menu-item a:focus,
.el-menu--popup .el-menu-item a:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  -moz-outline: none !important;
}

/* 2) 顶部水平菜单下的子菜单项里的 <a>（非弹层也兜住） */
.foto_navbar .el-sub-menu .el-menu-item a:focus,
.foto_navbar .el-sub-menu .el-menu-item a:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  -moz-outline: none !important;
}

/* 3) 抽屉里的左侧菜单 */
.left-menu .el-menu-item a:focus,
.left-menu .el-menu-item a:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  -moz-outline: none !important;
}

.el-menu .el-menu-item,
.el-menu .el-sub-menu__title {
  font-size: 16px !important;
}
.el-menu--horizontal > .el-menu-item {
  display: flex;
  align-items: center;
  font-weight: 700;
}
.el-sub-menu__title i {
  color: #000;
  font-weight: 700;
  font-size: 14px;
}

.left-menu .el-menu-item:hover,
.left-menu .el-sub-menu .el-menu-item a:hover,
.left-menu .el-sub-menu__title:hover {
  color: #3d3d3d;
  background: unset;
}

.left-menu .el-menu-item,
.left-menu .el-sub-menu__title {
  height: 41px;
  line-height: 41px;
  border-bottom: 1px solid #d8d8d8 !important;
  font-size: 14px !important;
  font-weight: 700;
}
.left-menu .el-sub-menu.is-active .el-sub-menu__title {
  border-bottom: 1px solid #d8d8d8 !important;
}

.left-menu .el-sub-menu .el-menu-item {
  padding: 0 20px !important;
  height: 33px;
  line-height: 33px;
  border-bottom: 1px solid #d8d8d8;
  font-weight: 700;
  font-size: 12px !important;
}
.el-drawer__body {
  padding: 0;
}
</style>

<style lang="scss" scoped>
.header {
  height: 60px;
  border-bottom: 3px solid #f2f2f2;
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: #3d3d3d;

  .btn_sign_up {
    display: inline-block;
    height: 38px;
    line-height: 38px;
    background: $themeColor;
    border-radius: 4px;
    color: #fff;
    box-sizing: border-box;
    padding: 0 24px;
    font-weight: 700;
    &:hover {
      color: #fff;
    }
  }
  .btn_account {
    color: $themeColor;
    &:hover {
      color: $themeColor;
    }
  }

  .account_area {
    display: flex;
    align-items: center;
  }

  .container {
    width: 100vw;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .logo_wrap {
      font-size: 0px;
      height: 100%;
      display: flex;
      align-items: center;
      a {
        display: inline-block;
        vertical-align: middle;
        width: 142px;
        height: 22px;
      }

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .more_navbar {
      cursor: pointer;
      display: none;
    }
  }
}

:deep(.foto_navbar) {
  .el-sub-menu__title {
    border-color: rgba(0, 0, 0, 0) !important;
    font-weight: 700;
  }
}

.hide_footer {
  display: none;
  margin: 5%;

  ul {
    li {
      margin-top: 10px;
    }
  }
}
.p-0 {
  padding: 0;
}

@media screen and (max-width: 1100px) {
  .hide_footer {
    display: block;
  }
}

@media screen and (min-width: 780px) and (max-width: 1100px) {
  // .header .container {
  // }

  .foto_navbar {
    display: none !important;
  }

  .more_navbar {
    display: block !important;
  }
}

@media screen and (max-width: 779px) {
  .header .container {
    max-width: 1024px;
  }

  .navbar ul {
    display: none !important;
  }

  .more_navbar {
    display: block !important;
  }

  .foto_navbar {
    display: none !important;
  }
}
@media only screen and (max-width: 680px) {
  .header-fixed {
    position: fixed;
    top: 0;
    z-index: 101;
    background: #fff;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}
</style>
